module.exports = __webpack_public_path__ + "static/media/sr.07e91c15.svg";